import R from 'ramda';
import Vue from 'vue';

export var applicationSlide = Vue.component({
	template: '#application-slide-template',
	props:['label', 'img_url'],
});



// WEBPACK FOOTER //
// ./resources/assets/js/vue/components/application-slide.js